import { Button, Dialog, Table, TableRow, Tag, Toast, Typography } from '@chilecompra/react-kit/components'
import PropTypes from 'prop-types'
import React from 'react'

import { VOID_STATES } from '../../../config/settings/constant'
import { PUBLIC_URL } from '../../../config/settings/environment'
import {
  Container,
  DialogButtons,
  DialogContent,
  DialogMessage,
  InfoIcon,
  Link,
  Skeleton,
  TableCell,
  TableContainer
} from '../HistoricalSanctionsList.styles'

const rows = ({ documentFile, documentType, resolutionNumber, supportDocumentDate }) => [
  { label: 'Tipo de documento', value: documentType || '-' },
  { label: 'Número de resolución', value: resolutionNumber || '-' },
  { label: 'Fecha documentación de respaldo', value: supportDocumentDate || '-' },
  {
    label: 'Acto administrativo',
    value: <Link to="#">{documentFile || '-'}</Link>
  },
  {
    label: 'Estado',
    value: (
      <Container>
        <Tag color="default" text={VOID_STATES.VOIDED} />
      </Container>
    )
  }
]

/**
 * The SanctionVoidDialog component.
 */
export const SanctionVoidDialog = ({ onCloseSanctionVoidDialog, sanctionVoidInfo, showSanctionVoidDialog = false }) => {
  return (
    <Dialog
      disableBackdropClick
      disableCloseIcon
      margin="auto"
      maxWidth="550px"
      onClose={onCloseSanctionVoidDialog}
      open={showSanctionVoidDialog}
      padding="32px"
    >
      <DialogContent flexDirection="column" gap="24px" padding="8px">
        <DialogMessage alignItems="center" flexDirection="column" gap="24px" justifyContent="center">
          <InfoIcon alt="Info icon" src={`${PUBLIC_URL}/assets/images/circle-info.svg`} />

          <Typography fontWeight="bold" variant="h4">
            Detalles de la sanción
          </Typography>

          <Toast severity="warning">
            Esta sanción ha sido anulada por la vía administrativa. Por lo tanto, no se tendrá en cuenta para el cálculo
            del comportamiento base del proveedor.
          </Toast>
        </DialogMessage>

        <DialogMessage flexDirection="column" gap="24px">
          <Typography fontWeight="bold" variant="body1">
            Detalles del acto administrativo que dejó sin efecto la sanción
          </Typography>

          <TableContainer className="void__table__container">
            <Table accessibility={{ label: 'Información de resolución con la cual se anuló la sanción' }}>
              {rows(sanctionVoidInfo.data).map(({ label, value }) => (
                <TableRow key={label}>
                  <TableCell className="cellHeader" disableBottomBorder padding="8px 0" width="300px">
                    <Typography fontWeight="bold" variant="body2">
                      {label}
                    </Typography>
                  </TableCell>

                  <TableCell disableBottomBorder padding="8px 0">
                    {sanctionVoidInfo.loading ? (
                      <Skeleton height="18px" width="100%" />
                    ) : typeof value === 'string' ? (
                      <Typography variant="body2">{value}</Typography>
                    ) : (
                      value
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </Table>
          </TableContainer>

          {!sanctionVoidInfo.loading && sanctionVoidInfo.error && (
            <Toast
              severity="error"
              textDirection="vertical"
              title="Lo sentimos, estamos presentando problemas con nuestro servidor."
            >
              En estos momentos tenemos problemas para disponibilizar la información. Por favor, consulta en unos
              minutos más.
            </Toast>
          )}
        </DialogMessage>

        <DialogButtons alignItems="center" justifyContent="center" margin="16px 0 0">
          <Button color="primary" onClick={onCloseSanctionVoidDialog}>
            Aceptar
          </Button>
        </DialogButtons>
      </DialogContent>
    </Dialog>
  )
}

SanctionVoidDialog.propTypes = {
  onCloseSanctionVoidDialog: PropTypes.func.isRequired,
  sanctionVoidInfo: PropTypes.shape({
    data: PropTypes.shape({
      documentFile: PropTypes.string,
      documentType: PropTypes.string,
      resolutionNumber: PropTypes.string,
      supportDocumentDate: PropTypes.string
    }),
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    loading: PropTypes.bool
  }).isRequired,
  showSanctionVoidDialog: PropTypes.bool
}
